var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"audio-player"},[_c('audio-player-controls',{attrs:{"current-time":_vm.playerTime,"trackSlug":_vm.currentTrack.slug,"hotspots":_vm.currentTrack.hotspots,"isPlaying":_vm.isPlaying},on:{"timeupdate":_vm.audioSetTime,"play":_vm.audioPlay,"pause":_vm.audioPause,"scrubbing":_vm.onScrubbing}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }